import { _ } from "core-js"
import Vue from "vue"

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.application.applicants.applicant,
    index: (state, getters, rootState) => _.get(rootState.appStore, 'application.applicants.applicant.index', 0)
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {
    setApplicant(state, applicant) {
        Vue.set(this.state.appStore.application.applicants, 'applicant', { ...state, ...applicant })
    },
    setEfd(state, applicant) {
        Vue.set(this.state.appStore.application.applicants, 'applicant', { ...state, ...applicant })
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    set({ commit }, applicant) {
        commit("setApplicant", applicant)
    },
    setEfd({ commit }, efd) {
        commit("setEfd", efd)
    },
}

export default {
    namespaced: true,
    namespace: "application/applicants/applicant",
    modules: getModules('applicant'),
    state: {},
    getters,
    mutations,
    actions,
}
